import { message } from "antd";
import { SectionStatus } from "../enums/SubSectionStatus";
import { TruckMaterialType } from "../enums/truckMaterialType";

export const getFormattedOrderList = (
  dataList?: [],
  orderType: TruckMaterialType,
) => {
  return dataList
    ?.filter((item) => item.type === orderType)
    ?.map((item) => ({
      ...item,
      pickupLocation: item?.pickUpAddress,
      milesDuration: item?.duration?.text,
      materialTruckName: item?.materialName,
      isBlocked: !!item?.isBlocked,
    }));
};

export const getFormattedApprovalDocuments = (
  uploadedFiles,
  approvalDocuments,
  newDocuments,
  deletedDocuments,
  isApprovalInfoChanged,
) => {
  const approvalDocumentsTemplate = {
    "Project Info Section": {
      documentAttachments: [],
      review: [],
      status: SectionStatus.PENDING,
    },
    "Property Legal Description": {
      documentAttachments: [],
      review: [],
      status: SectionStatus.PENDING,
    },
    "Property Owner Information": {
      documentAttachments: [],
      review: [],
      status: SectionStatus.PENDING,
    },
    "General Contractor Information": {
      documentAttachments: [],
      review: [],
      status: SectionStatus.PENDING,
    },
    "Subcontractor Information": {
      documentAttachments: [],
      review: [],
      status: SectionStatus.PENDING,
    },
    "Bond Information": {
      documentAttachments: [],
      review: [],
      status: SectionStatus.PENDING,
    },
  };

  //Map doc ids to docAttachments
  uploadedFiles?.forEach((doc) => {
    const section = doc.docType;
    if (approvalDocumentsTemplate[section]) {
      approvalDocumentsTemplate[section].documentAttachments.push(doc.id);
    }
  });

  if (isApprovalInfoChanged) {
    Object?.keys(approvalDocumentsTemplate)?.forEach((section) => {
      approvalDocumentsTemplate[section].status = SectionStatus?.PENDING;
      approvalDocumentsTemplate[section].review = [];
    });
    return approvalDocumentsTemplate;
  }

  if (approvalDocuments) {
    Object.keys(approvalDocumentsTemplate).forEach((section) => {
      const existing = approvalDocuments?.[section];

      if (
        existing?.status === SectionStatus.L1_REJECTED ||
        existing?.status === SectionStatus.L2_REJECTED
      ) {
        approvalDocumentsTemplate[section].review = [];
        approvalDocumentsTemplate[section].status = SectionStatus.PENDING;
      }
      if (
        existing?.status === SectionStatus.L1_APPROVED ||
        existing?.status === SectionStatus.L2_APPROVED
      ) {
        const isApprovedSectionHasNewDocument = newDocuments?.some(
          (doc) => doc?.docType === section,
        );
        // check if approved section has deleted some document.
        const isApprovedSectionHasDeletedDocument = deletedDocuments?.some(
          (doc) => doc?.docType === section,
        );
        if (
          isApprovedSectionHasNewDocument ||
          isApprovedSectionHasDeletedDocument
        ) {
          approvalDocumentsTemplate[section].review = [];
          approvalDocumentsTemplate[section].status = SectionStatus.PENDING;
        } else {
          approvalDocumentsTemplate[section].review = existing?.review;
          approvalDocumentsTemplate[section].status = existing?.status;
        }
      }
    });
  }
  return approvalDocumentsTemplate;
};

export const validateRejectedSectionsHaveDocs = (
  approvalDocuments,
  newDocuments,
) => {
  if (!approvalDocuments) {
    return true;
  }

  const missingSections = [];
  Object.entries(approvalDocuments).forEach(([sectionTitle, sectionData]) => {
    const status = sectionData?.status;
    const isRejected =
      status === SectionStatus.L1_REJECTED ||
      status === SectionStatus.L2_REJECTED;

    if (isRejected) {
      const hasDoc = newDocuments.some((doc) => doc?.docType === sectionTitle);

      if (!hasDoc) {
        missingSections.push(sectionTitle);
      }
    }
  });

  if (missingSections.length > 0) {
    message.error(
      `Missing re-uploads for rejected sections: ${missingSections.join(", ")}`,
    );
  }
  return missingSections.length === 0;
};

export const hasDocsForSections = (sections: string[], docs: any[]) => {
  return sections?.every((section) =>
    docs?.some((doc) => doc?.docType === section),
  );
};
